import { GuiOpenUrlWith } from '../api/v2/Models/GuiComponentApiModel';

export interface ComponentIdentityButtonIconSpecification {
	id: number;
	title: string;
	subtitle: string;
	url: string;
	openUrlWith: GuiOpenUrlWith;
	requiresAuthentication: boolean;
	openAnotherApp: boolean;
	hasBrandedNavbar: boolean;
	imageUrl: string;
}

export class ComponentIdentityButtonIcon {
	public readonly id: number;
	public readonly title: string;
	public readonly url: string;
	public readonly openUrlWith: GuiOpenUrlWith;
	public readonly requiresAuthentication: boolean;
	public readonly openAnotherApp: boolean;
	public readonly hasBrandedNavbar: boolean;
	public readonly imageUrl: string;
	public readonly subtitle: string;

	constructor(spec: ComponentIdentityButtonIconSpecification) {
		this.id = spec.id;
		this.title = spec.title;
		this.url = spec.openUrlWith === 'IFrame' ? encodeURIComponent(spec.url) : spec.url;
		this.openUrlWith = spec.openUrlWith;
		this.requiresAuthentication = spec.requiresAuthentication;
		this.openAnotherApp = spec.openAnotherApp;
		this.hasBrandedNavbar = spec.hasBrandedNavbar;
		this.imageUrl = spec.imageUrl;
		this.subtitle = spec.subtitle;
	}
}
